// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KVUyT","newExpiryDate":"styles_newExpiryDate__1mu70","footer":"styles_footer__2Grng"};